import { PopoverContext } from '@context/popover-context';
import useNode from '@hooks/use-node';
import { TextArea } from '@ui-lib';
import { useContext, useEffect } from 'react';

interface HeadlineEditPopoverProps {
  field: string;
  onChange: (field: string) => void;
  placeholder?: string;
}

const HeadlineEditPopover: React.FC<React.PropsWithChildren<HeadlineEditPopoverProps>> = ({
  field,
  onChange,
  placeholder,
}) => {
  const { show } = useContext(PopoverContext);
  const [inputNode, inputRef] = useNode<HTMLTextAreaElement>();

  useEffect(() => {
    if (show && inputNode) {
      const intersectionObserver = new IntersectionObserver((entries, observer) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setTimeout(() => {
            inputNode.focus();
            inputNode.setSelectionRange(inputNode.value.length, inputNode.value.length);
          }, 150);
          observer.unobserve(entry.target);
        }
      });

      intersectionObserver.observe(inputNode);
    }
  }, [show, inputNode]);

  return (
    <TextArea
      ref={inputRef}
      value={field}
      onChange={(event) => onChange(event.currentTarget.value)}
      label="Headline"
      placeholder={placeholder}
    />
  );
};

export default HeadlineEditPopover;
